import { VitRegistrationStatus } from "../VitRegistrationStatus";

export const VitRegistrationStatusLabels: Record<
  VitRegistrationStatus,
  string
> = {
  [VitRegistrationStatus.ProvisionalRegistration]: "Provisional registration",
  [VitRegistrationStatus.FullRegistration]: "Full registration",
  [VitRegistrationStatus.PermissionToTeach]: "Permission to teach",
  [VitRegistrationStatus.ApplicationInProgressWithTheVit]:
    "Application in progress with the VIT",
  [VitRegistrationStatus.IntendToApplySoon]: "I intend to apply soon",
};
